import { KSSIdentifiers } from "@preveil-api";
import { keyStorageServerAPI as api } from "../base";

// ------------------------------------------------------------
// RTK Queries Calls: 
// ------------------------------------------------------------
const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    deleteUser: build.mutation<DeleteUserApiResponse, DeleteUserApiArg>({
      query: (queryArg) => ({
        url: `/users/${queryArg.user_id}`,
        method: "DELETE",
        headers: { "x-auth-token": queryArg.auth_token }
      }),
    }),
    isRecoverySetUp: build.query<IsRecoverySetUpApiResponse, IsRecoverySetUpApiArg>({
      query: (queryArg) => ({
        url: `/users/${queryArg.user_id}/shard_metadata`,
        method: "GET",
        headers: { "x-auth-token": queryArg.auth_token }
      }),
    }),
    getAuthenticationMethod: build.query<GetAuthenticationMethodApiResponse, GetAuthenticationMethodApiArg>({
      query: (queryArg) => ({
        url: `/users/${queryArg.user_id}/secondary_auth_method`,
        method: "GET",
        headers: { "x-auth-token": queryArg.auth_token }
      }),
    }),
  }),
  overrideExisting: false,
});

// GENERAL EXPORTS OF TYPES AND HOOKS:
export { injectedRtkApi as keystorageApi };

// ------------------------------------------------------------
// Request and Response types:
// ------------------------------------------------------------
export type DeleteUserApiResponse = unknown;
export type DeleteUserApiArg = KSSIdentifiers;
export type IsRecoverySetUpApiResponse = {
  server_shard_exists: boolean;
};
export type IsRecoverySetUpApiArg = KSSIdentifiers;

export type GetAuthenticationMethodApiResponse = {
  authentication_method: string; // either "sms" or "totp"
};
export type GetAuthenticationMethodApiArg = KSSIdentifiers;

// Export hooks
export const { useDeleteUserMutation, useIsRecoverySetUpQuery, useGetAuthenticationMethodQuery } = injectedRtkApi;
